
import {
    UPDATE_USER_NOTES
} from '../../GlobalStateContainer'

export const UserNotes = function (state = '', action) {
    switch (action.type) {
        case UPDATE_USER_NOTES:
            return action.userNotes;
        default: return state;
    }
}